export default "__VITE_ASSET__$084rqKM0UkHF8fts0$_vw__"